import { render, staticRenderFns } from "./SenseiCharges.vue?vue&type=template&id=35f74de2&scoped=true&"
import script from "./SenseiCharges.vue?vue&type=script&lang=js&"
export * from "./SenseiCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f74de2",
  null
  
)

export default component.exports